import React from 'react';
import './timetable.scss';

import { useCheckUserAuthentication,fetchLookup} from '../../globals';

import CustomerStatus from './customerStatus.js';
import CustomerDue from './customerDue.js';

import SupplierStatus from './supplierStatus.js';
import SupplierDue from './supplierDue.js';

import { TabPanel, Item as TabPanelItem} from 'devextreme-react/tab-panel';
import { useState,  useCallback, useEffect} from "react";

import { SelectBox } from 'devextreme-react/select-box';


export default function TimeTable() {


  const [selectedIndex, setSelectedIndex] = useState(0);

  const [commessaFilter, setCommessaFilter] = useState(0);
  const [intermediarioFilter, setIntermediarioFilter] = useState(210);

  const [commesse, setCommesse] = useState({});
  const [intermediari, setIntermediari] = useState({});

  const onTabSelectionChanged = useCallback((args) => {
    if (args.name === 'selectedIndex') {
      setSelectedIndex(args.value);
    }
  }, []);

  const user = useCheckUserAuthentication();

  useEffect(() => {
  
    const newServiceUrl1 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/View_Commesse';
    var newUrl1 =  newServiceUrl1 + "/GetOpen";

    const newServiceUrl7 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/Anagrafica';
    var newUrl7 =  newServiceUrl7 + "/GetIntermediari";

    const fetchData = async () => {

      if (!user?.token) {
        return;
      }

      try {

        const requestOptions = {
          headers: {
            Authorization: `Bearer ${user.token}`
          }
        };

        const json1 = await fetchLookup(newUrl1,requestOptions);
        if (json1) {
          setCommesse(json1);
        }

        const json7 = await fetchLookup(newUrl7,requestOptions);
        if (json7) {
          setIntermediari(json7);
        }

      } catch (error) {
        console.log("error", error);
      }
    };
    fetchData();
  }, []);

  return (
  <React.Fragment>
    <h2 className={'content-block'}>Movimenti</h2>

    <div className={'content-block'}>
      <div className={'dx-card responsive-paddings'}>
       
    <div className="filters-container">
      <SelectBox
        className="filter-select"
        items={intermediari}
        valueExpr="id"
        placeholder="<Azienda>"
        displayExpr="ragioneSociale"
        showClearButton="true"
        value={intermediarioFilter}
        onValueChanged={(e) => setIntermediarioFilter(e.value)}
      />

       <SelectBox
        className="filter-select"
        items={commesse}
        valueExpr="id"
        placeholder="<Commessa>"
        displayExpr="nomeEsteso"
        showClearButton="true"
        value={commessaFilter}
        onValueChanged={(e) => setCommessaFilter(e.value)}
      />
    </div>

      <TabPanel    
        onOptionChanged={onTabSelectionChanged}
      >
        <TabPanelItem 
          title="Consegne Fornitori" 
          render={() => (
            <SupplierStatus 
              commessaFilter={commessaFilter}
              intermediarioFilter={intermediarioFilter}
            />
          )} 
        />
        <TabPanelItem 
          title="Pagamenti" 
          render={() => (
            <SupplierDue 
              commessaFilter={commessaFilter}
              intermediarioFilter={intermediarioFilter}
            />
          )} 
        />
        <TabPanelItem 
          title="Consegne Clienti" 
          render={() => (
            <CustomerStatus 
              commessaFilter={commessaFilter}
              intermediarioFilter={intermediarioFilter}
            />
          )} 
        />
        <TabPanelItem 
          title="Incassi" 
          render={() => (
            <CustomerDue 
              commessaFilter={commessaFilter}
              intermediarioFilter={intermediarioFilter}
            />
          )} 
        />
      </TabPanel>
       
      </div>
    </div>
  </React.Fragment>
)
};
